import React from 'react'

export const MessengerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 0C3.13425 0 0 2.88344 0 6.44C0 8.34468 0.904557 10.0505 2.33333 11.2295V14L5.1543 12.6459C5.74322 12.7939 6.36009 12.88 7 12.88C10.8657 12.88 14 9.99656 14 6.44C14 2.88344 10.8657 0 7 0ZM6.33577 4.68016L8.05729 6.335L11.1323 4.68016L7.66422 8.28844L5.98258 6.55375L2.82666 8.24906L6.33577 4.68016Z"
      fill="currentColor"
    />
  </svg>
)
